// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__396Ls","approved":"Status_approved__3ir0n","rejected":"Status_rejected__3zAsf","expired":"Status_expired__RpVAJ","label":"Status_label__1eSEq"};